import { Input } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { CalendarFieldIcon } from 'BreetAssets';
import { forwardRef } from 'react';

import type { ITriggerProps } from './DatePicker.helpers';

export const DatePickerTrigger = forwardRef<HTMLInputElement, ITriggerProps>(
	({ label, id, errorMessage, placeholder, calendarIconVariant, disabled, ...injected }, ref) => (
		<div className='bt_datePicker_field'>
			<Input
				ref={ref}
				{...injected}
				label={label}
				id={id}
				widthType='full'
				placeholder={placeholder ?? ' '}
				errorMessage={errorMessage}
				disabled={disabled}
				readOnly
			/>
			<CalendarFieldIcon
				className={classNameMerger('bt_datePicker_field_icon', calendarIconVariant)}
				aria-hidden
				focusable={false}
				variant={calendarIconVariant}
			/>
		</div>
	)
);

DatePickerTrigger.displayName = 'DatePickerTrigger';
